import { Component, Input, OnInit } from '@angular/core';
import { Member } from '../../../../models/clubs/member.model';
import { ReactionType } from './../../../../models/clubs/reaction-type.model';
import { Reaction } from './../../../../models/clubs/reaction.model';

@Component({
    selector: 'app-modal-publication-reactions-details',
    templateUrl: './modal-publication-reactions-details.html',
    styleUrls: ['./modal-publication-reactions-details.scss'],
})
export class ModalPublicationReactionDetailsComponent implements OnInit {
    @Input()
    reactionsDetails: Reaction[];

    @Input()
    reactionTypes: ReactionType[];

    displayModal: boolean;

    @Input()
    membersAssociatedToReactions: { member: Member; reaction: Reaction }[] = [];

    get nbReactions(): number {
        return this.membersAssociatedToReactions?.length;
    }

    constructor() {}

    ngOnInit(): void    {    }

    public showModalDialog() {
        this.displayModal = true;
    }

    getReactionTypeCode(reactionTypeId: string): string {
        return this.reactionTypes?.find((reactionType) => reactionType.id == reactionTypeId)?.code;
    }
}
